// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("spudfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("spudfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("spudfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("spudfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#spudfont" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*?cqksbc*/
@font-face {
  font-family: 'spudfont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'spudfont' !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: 16px;
}

.icon-flip-y {
    transform: rotate(180deg);
}

.side-menu [class^="icon-"], .side-menu [class*=" icon-"] {
    font-size: 20px;
}

[class^="icon-"].white, [class*=" icon-"].white {
    color: #fff;
}

.icon-activity:before {
  content: "\\e900";
}
.icon-bell:before {
  content: "\\e901";
}
.icon-bell-off:before {
  content: "\\e902";
}
.icon-grid:before {
  content: "\\e903";
}
.icon-home:before {
  content: "\\e904";
}
.icon-inbox:before {
  content: "\\e905";
}
.icon-layout:before {
  content: "\\e906";
}
.icon-more-vertical:before {
  content: "\\e907";
}
.icon-server:before {
  content: "\\e908";
}
.icon-terminal:before {
  content: "\\e909";
}
.icon-toggle-left:before {
  content: "\\e90a";
}
.icon-toggle-right:before {
  content: "\\e90b";
}
.icon-tool:before {
  content: "\\e90c";
}
.icon-x:before {
  content: "\\e90d";
}
.icon-x-circle:before {
  content: "\\e90e";
}
.icon-x-square:before {
  content: "\\e90f";
}
.icon-chart-bar:before {
  content: "\\e910";
}
.icon-redo:before {
  content: "\\e911";
}
.icon-undo:before {
  content: "\\e912";
}
.icon-list-numbered:before {
  content: "\\e913";
}
.icon-arrange:before {
  content: "\\e914";
}
.icon-reload:before {
  content: "\\e915";
}
.icon-paragraph:before {
  content: "\\e916";
}
.icon-home1:before {
  content: "\\e917";
}
.icon-sign-out:before {
  content: "\\e918";
}
.icon-minus:before {
  content: "\\e919";
}
.icon-plus:before {
  content: "\\e91a";
}
.icon-delete:before {
  content: "\\e91b";
}
.icon-cart-selected:before {
  content: "\\e91c";
}
.icon-warning:before {
  content: "\\e91d";
}
.icon-underline:before {
  content: "\\e91e";
}
.icon-settings:before {
  content: "\\e91f";
}
.icon-search:before {
  content: "\\e920";
}
.icon-info:before {
  content: "\\e921";
}
.icon-question:before {
  content: "\\e922";
}
.icon-indent-more:before {
  content: "\\e923";
}
.icon-indent-less:before {
  content: "\\e924";
}
.icon-text:before {
  content: "\\e925";
}
.icon-layout-vertical:before {
  content: "\\e926";
}
.icon-layout-horizontal:before {
  content: "\\e927";
}
.icon-visible:before {
  content: "\\e928";
}
.icon-hidden:before {
  content: "\\e929";
}
.icon-filter:before {
  content: "\\e92a";
}
.icon-flag:before {
  content: "\\e92b";
}
.icon-download:before {
  content: "\\e92c";
}
.icon-checkbox-empty:before {
  content: "\\e92d";
}
.icon-checkbox-checked:before {
  content: "\\e92e";
}
.icon-check:before {
  content: "\\e92f";
}
.icon-code:before {
  content: "\\e930";
}
.icon-attach:before {
  content: "\\e931";
}
.icon-list-bullet:before {
  content: "\\e932";
}
.icon-list:before {
  content: "\\e933";
}
.icon-book:before {
  content: "\\e934";
}
.icon-link:before {
  content: "\\e935";
}
.icon-link-break:before {
  content: "\\e936";
}
.icon-align-right:before {
  content: "\\e937";
}
.icon-align-left:before {
  content: "\\e938";
}
.icon-align-justify:before {
  content: "\\e939";
}
.icon-align-center:before {
  content: "\\e93a";
}
.icon-clock:before {
  content: "\\e93b";
}
.icon-user-group:before {
  content: "\\e93c";
}
.icon-user:before {
  content: "\\e93d";
}
.icon-user-id:before {
  content: "\\e93e";
}
.icon-user-card:before {
  content: "\\e93f";
}
.icon-user-pair:before {
  content: "\\e940";
}
.icon-user-remove:before {
  content: "\\e941";
}
.icon-user-add:before {
  content: "\\e942";
}
.icon-star:before {
  content: "\\e943";
}
.icon-certificate-1:before {
  content: "\\e944";
}
.icon-certificate-2:before {
  content: "\\e945";
}
.icon-face-neutral:before {
  content: "\\e946";
}
.icon-face-sad:before {
  content: "\\e947";
}
.icon-face-happy:before {
  content: "\\e948";
}
.icon-receipt:before {
  content: "\\e949";
}
.icon-qr-code:before {
  content: "\\e94a";
}
.icon-sale:before {
  content: "\\e94b";
}
.icon-cart:before {
  content: "\\e94c";
}
.icon-lock:before {
  content: "\\e94d";
}
.icon-shield:before {
  content: "\\e94e";
}
.icon-card-secure:before {
  content: "\\e94f";
}
.icon-photo:before {
  content: "\\e950";
}
.icon-picture:before {
  content: "\\e951";
}
.icon-image-add:before {
  content: "\\e952";
}
.icon-image:before {
  content: "\\e953";
}
.icon-phone:before {
  content: "\\e954";
}
.icon-dollar:before {
  content: "\\e955";
}
.icon-money:before {
  content: "\\e956";
}
.icon-paint:before {
  content: "\\e957";
}
.icon-message:before {
  content: "\\e958";
}
.icon-location:before {
  content: "\\e959";
}
.icon-transfer:before {
  content: "\\e95a";
}
.icon-medical:before {
  content: "\\e95b";
}
.icon-love:before {
  content: "\\e95c";
}
.icon-folder:before {
  content: "\\e95d";
}
.icon-folder-open:before {
  content: "\\e95e";
}
.icon-file-edit:before {
  content: "\\e95f";
}
.icon-file:before {
  content: "\\e960";
}
.icon-file-user:before {
  content: "\\e961";
}
.icon-file-search:before {
  content: "\\e962";
}
.icon-email:before {
  content: "\\e963";
}
.icon-font-colour:before {
  content: "\\e964";
}
.icon-mail:before {
  content: "\\e965";
}
.icon-mail-open:before {
  content: "\\e966";
}
.icon-send:before {
  content: "\\e967";
}
.icon-sending:before {
  content: "\\e968";
}
.icon-picker:before {
  content: "\\e969";
}
.icon-scale:before {
  content: "\\e96a";
}
.icon-font-family:before {
  content: "\\e96b";
}
.icon-erase:before {
  content: "\\e96c";
}
.icon-copy:before {
  content: "\\e96d";
}
.icon-files:before {
  content: "\\e96e";
}
.icon-edit:before {
  content: "\\e96f";
}
.icon-document:before {
  content: "\\e970";
}
.icon-document-edit:before {
  content: "\\e971";
}
.icon-print:before {
  content: "\\e972";
}
.icon-chart-pie:before {
  content: "\\e973";
}
.icon-arrow-back:before {
  content: "\\e974";
}
.icon-forward:before {
  content: "\\e975";
}
.icon-back:before {
  content: "\\e976";
}
.icon-font-size:before {
  content: "\\e977";
}
.icon-font-italic:before {
  content: "\\e978";
}
.icon-font-bold:before {
  content: "\\e979";
}
.icon-font-clear-style:before {
  content: "\\e97a";
}
.icon-video:before {
  content: "\\e97b";
}
.icon-box:before {
  content: "\\e97c";
}
.icon-arrow-up:before {
  content: "\\e97d";
}
.icon-cart-add:before {
  content: "\\e97e";
}

.icon-hyperlink:before {
  content: "\\e935"; /* unicode for hyperlink icon */
}

.text-editor a {
  color: #0052CC; /* Custom color for hyperlinks */
  text-decoration: underline;
}

.text-editor a:hover {
  color: #0052CC; /* Color on hover */
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts/font-style.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,uBAAuB;EACvB,4CAAwB;EACxB;;;yDAG4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;;EAElC,eAAe;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,0BAA0B;AAC5B;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,0BAA0B;AAC5B","sourcesContent":["/*?cqksbc*/\n@font-face {\n  font-family: 'spudfont';\n  src: url('spudfont.eot');\n  src: url('spudfont.eot#iefix') format('embedded-opentype'),\n    url('spudfont.woff') format('woff'),\n    url('spudfont.ttf') format('truetype'),\n    url('spudfont.svg#spudfont') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\ni {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'spudfont' !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  font-size: 16px;\n}\n\n.icon-flip-y {\n    transform: rotate(180deg);\n}\n\n.side-menu [class^=\"icon-\"], .side-menu [class*=\" icon-\"] {\n    font-size: 20px;\n}\n\n[class^=\"icon-\"].white, [class*=\" icon-\"].white {\n    color: #fff;\n}\n\n.icon-activity:before {\n  content: \"\\e900\";\n}\n.icon-bell:before {\n  content: \"\\e901\";\n}\n.icon-bell-off:before {\n  content: \"\\e902\";\n}\n.icon-grid:before {\n  content: \"\\e903\";\n}\n.icon-home:before {\n  content: \"\\e904\";\n}\n.icon-inbox:before {\n  content: \"\\e905\";\n}\n.icon-layout:before {\n  content: \"\\e906\";\n}\n.icon-more-vertical:before {\n  content: \"\\e907\";\n}\n.icon-server:before {\n  content: \"\\e908\";\n}\n.icon-terminal:before {\n  content: \"\\e909\";\n}\n.icon-toggle-left:before {\n  content: \"\\e90a\";\n}\n.icon-toggle-right:before {\n  content: \"\\e90b\";\n}\n.icon-tool:before {\n  content: \"\\e90c\";\n}\n.icon-x:before {\n  content: \"\\e90d\";\n}\n.icon-x-circle:before {\n  content: \"\\e90e\";\n}\n.icon-x-square:before {\n  content: \"\\e90f\";\n}\n.icon-chart-bar:before {\n  content: \"\\e910\";\n}\n.icon-redo:before {\n  content: \"\\e911\";\n}\n.icon-undo:before {\n  content: \"\\e912\";\n}\n.icon-list-numbered:before {\n  content: \"\\e913\";\n}\n.icon-arrange:before {\n  content: \"\\e914\";\n}\n.icon-reload:before {\n  content: \"\\e915\";\n}\n.icon-paragraph:before {\n  content: \"\\e916\";\n}\n.icon-home1:before {\n  content: \"\\e917\";\n}\n.icon-sign-out:before {\n  content: \"\\e918\";\n}\n.icon-minus:before {\n  content: \"\\e919\";\n}\n.icon-plus:before {\n  content: \"\\e91a\";\n}\n.icon-delete:before {\n  content: \"\\e91b\";\n}\n.icon-cart-selected:before {\n  content: \"\\e91c\";\n}\n.icon-warning:before {\n  content: \"\\e91d\";\n}\n.icon-underline:before {\n  content: \"\\e91e\";\n}\n.icon-settings:before {\n  content: \"\\e91f\";\n}\n.icon-search:before {\n  content: \"\\e920\";\n}\n.icon-info:before {\n  content: \"\\e921\";\n}\n.icon-question:before {\n  content: \"\\e922\";\n}\n.icon-indent-more:before {\n  content: \"\\e923\";\n}\n.icon-indent-less:before {\n  content: \"\\e924\";\n}\n.icon-text:before {\n  content: \"\\e925\";\n}\n.icon-layout-vertical:before {\n  content: \"\\e926\";\n}\n.icon-layout-horizontal:before {\n  content: \"\\e927\";\n}\n.icon-visible:before {\n  content: \"\\e928\";\n}\n.icon-hidden:before {\n  content: \"\\e929\";\n}\n.icon-filter:before {\n  content: \"\\e92a\";\n}\n.icon-flag:before {\n  content: \"\\e92b\";\n}\n.icon-download:before {\n  content: \"\\e92c\";\n}\n.icon-checkbox-empty:before {\n  content: \"\\e92d\";\n}\n.icon-checkbox-checked:before {\n  content: \"\\e92e\";\n}\n.icon-check:before {\n  content: \"\\e92f\";\n}\n.icon-code:before {\n  content: \"\\e930\";\n}\n.icon-attach:before {\n  content: \"\\e931\";\n}\n.icon-list-bullet:before {\n  content: \"\\e932\";\n}\n.icon-list:before {\n  content: \"\\e933\";\n}\n.icon-book:before {\n  content: \"\\e934\";\n}\n.icon-link:before {\n  content: \"\\e935\";\n}\n.icon-link-break:before {\n  content: \"\\e936\";\n}\n.icon-align-right:before {\n  content: \"\\e937\";\n}\n.icon-align-left:before {\n  content: \"\\e938\";\n}\n.icon-align-justify:before {\n  content: \"\\e939\";\n}\n.icon-align-center:before {\n  content: \"\\e93a\";\n}\n.icon-clock:before {\n  content: \"\\e93b\";\n}\n.icon-user-group:before {\n  content: \"\\e93c\";\n}\n.icon-user:before {\n  content: \"\\e93d\";\n}\n.icon-user-id:before {\n  content: \"\\e93e\";\n}\n.icon-user-card:before {\n  content: \"\\e93f\";\n}\n.icon-user-pair:before {\n  content: \"\\e940\";\n}\n.icon-user-remove:before {\n  content: \"\\e941\";\n}\n.icon-user-add:before {\n  content: \"\\e942\";\n}\n.icon-star:before {\n  content: \"\\e943\";\n}\n.icon-certificate-1:before {\n  content: \"\\e944\";\n}\n.icon-certificate-2:before {\n  content: \"\\e945\";\n}\n.icon-face-neutral:before {\n  content: \"\\e946\";\n}\n.icon-face-sad:before {\n  content: \"\\e947\";\n}\n.icon-face-happy:before {\n  content: \"\\e948\";\n}\n.icon-receipt:before {\n  content: \"\\e949\";\n}\n.icon-qr-code:before {\n  content: \"\\e94a\";\n}\n.icon-sale:before {\n  content: \"\\e94b\";\n}\n.icon-cart:before {\n  content: \"\\e94c\";\n}\n.icon-lock:before {\n  content: \"\\e94d\";\n}\n.icon-shield:before {\n  content: \"\\e94e\";\n}\n.icon-card-secure:before {\n  content: \"\\e94f\";\n}\n.icon-photo:before {\n  content: \"\\e950\";\n}\n.icon-picture:before {\n  content: \"\\e951\";\n}\n.icon-image-add:before {\n  content: \"\\e952\";\n}\n.icon-image:before {\n  content: \"\\e953\";\n}\n.icon-phone:before {\n  content: \"\\e954\";\n}\n.icon-dollar:before {\n  content: \"\\e955\";\n}\n.icon-money:before {\n  content: \"\\e956\";\n}\n.icon-paint:before {\n  content: \"\\e957\";\n}\n.icon-message:before {\n  content: \"\\e958\";\n}\n.icon-location:before {\n  content: \"\\e959\";\n}\n.icon-transfer:before {\n  content: \"\\e95a\";\n}\n.icon-medical:before {\n  content: \"\\e95b\";\n}\n.icon-love:before {\n  content: \"\\e95c\";\n}\n.icon-folder:before {\n  content: \"\\e95d\";\n}\n.icon-folder-open:before {\n  content: \"\\e95e\";\n}\n.icon-file-edit:before {\n  content: \"\\e95f\";\n}\n.icon-file:before {\n  content: \"\\e960\";\n}\n.icon-file-user:before {\n  content: \"\\e961\";\n}\n.icon-file-search:before {\n  content: \"\\e962\";\n}\n.icon-email:before {\n  content: \"\\e963\";\n}\n.icon-font-colour:before {\n  content: \"\\e964\";\n}\n.icon-mail:before {\n  content: \"\\e965\";\n}\n.icon-mail-open:before {\n  content: \"\\e966\";\n}\n.icon-send:before {\n  content: \"\\e967\";\n}\n.icon-sending:before {\n  content: \"\\e968\";\n}\n.icon-picker:before {\n  content: \"\\e969\";\n}\n.icon-scale:before {\n  content: \"\\e96a\";\n}\n.icon-font-family:before {\n  content: \"\\e96b\";\n}\n.icon-erase:before {\n  content: \"\\e96c\";\n}\n.icon-copy:before {\n  content: \"\\e96d\";\n}\n.icon-files:before {\n  content: \"\\e96e\";\n}\n.icon-edit:before {\n  content: \"\\e96f\";\n}\n.icon-document:before {\n  content: \"\\e970\";\n}\n.icon-document-edit:before {\n  content: \"\\e971\";\n}\n.icon-print:before {\n  content: \"\\e972\";\n}\n.icon-chart-pie:before {\n  content: \"\\e973\";\n}\n.icon-arrow-back:before {\n  content: \"\\e974\";\n}\n.icon-forward:before {\n  content: \"\\e975\";\n}\n.icon-back:before {\n  content: \"\\e976\";\n}\n.icon-font-size:before {\n  content: \"\\e977\";\n}\n.icon-font-italic:before {\n  content: \"\\e978\";\n}\n.icon-font-bold:before {\n  content: \"\\e979\";\n}\n.icon-font-clear-style:before {\n  content: \"\\e97a\";\n}\n.icon-video:before {\n  content: \"\\e97b\";\n}\n.icon-box:before {\n  content: \"\\e97c\";\n}\n.icon-arrow-up:before {\n  content: \"\\e97d\";\n}\n.icon-cart-add:before {\n  content: \"\\e97e\";\n}\n\n.icon-hyperlink:before {\n  content: \"\\e935\"; /* unicode for hyperlink icon */\n}\n\n.text-editor a {\n  color: #0052CC; /* Custom color for hyperlinks */\n  text-decoration: underline;\n}\n\n.text-editor a:hover {\n  color: #0052CC; /* Color on hover */\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
